import React, { useContext, useEffect, useState } from 'react'
import iiitblogo from "../images/iiitb_logo.png";
import { useNavigate, useParams } from 'react-router-dom';
import HelpIcon from "../images/help_chat.png";
import { LogOut, UserIcon } from 'lucide-react';
import LogoutButton from './LogoutButton';
import { LoginContext } from '../context/LoginContext';
import apiConfig from '../config/apiConfig';
import { Round } from './Resource/ViewRounds';
import { apiFetch } from '../apis/apiFetch';
import { useQuery } from '@tanstack/react-query';
import { toast } from '../utils/toast';
import moment from "moment";

interface AnalyticsCounts {
    // Mtech

    programme1: string;
    programme2: string;
    programme3: string;
    programme4: string;
    programme5: string;

    seatsavailable1: number;
    seatsavailable2: number;
    seatsavailable3: number;
    seatsavailable4: number;
    seatsavailable5: number;

    lastUpdated1: string;
    lastUpdated2: string;
    lastUpdated3: string;
    lastUpdated4: string;
    lastUpdated5: string;

}

const programmeFullNames: Record<string, string> = {
    "MTech_CSE": "MTech_CSE",
    "MTech_ECE": "MTech_ECE",
    "MTech_AI_DS": "MTech_AI&DS",
    "BTech_CSE": "B.Tech. (Computer Science and Engineering)",
    "BTech_ECE": "B.Tech. (Electronics and Communication Engineering)",
    "BTech_AI_DS": "B.Tech. (Artificial Intelligence & Data Science)",
    "I_MTech_CSE": "Integrated M.Tech (Computer Science and Engineering)",
    "I_MTech_ECE": "Integrated M.Tech. (Electronics and Communication Engineering)"
};

function BtechOnlineRoundDisplay() {
    const navigate = useNavigate();
    const { user } = useContext(LoginContext);
    const isAdmin = user.role === "admin"
    const { appId: id } = useParams();
    const [token, setToken] = useState<number | null>(null)

    const n = (val: number | undefined) => (val ?? 0);

    const userEmail = user?.email_id || "Student";
    const [analytics, setAnalytics] = useState<any>(null);
    const [analyticsLoading, setAnalyticsLoading] = useState(false);
    const [rounds, setRounds] = useState<Round[]>([]);
    const [selectedRound, setSelectedRound] = useState<Round | null>(null);
    const [drives, setDrives] = useState<any[]>([]);
    const [isConfirming, setIsConfirming] = useState(false);
    const [loading, setLoading] = useState(false)
    const [searchText, setSearchText] = useState("");


    const fetchRounds = async () => {
        try {
            const url = `${apiConfig.getResourceUrl("rounds")}?queryId=GET_ALL`;
            const response = await apiFetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            let rawRounds = [];
            if (Array.isArray(data)) rawRounds = data;
            else if (data && Array.isArray(data.resource)) rawRounds = data.resource;
            else if (data && Array.isArray(data.records)) rawRounds = data.records;

            const sorted = rawRounds.sort((a: any, b: any) => {
                const parseDate = (val: any) => {
                    if (!val) return 0;
                    const d = new Date(val);
                    if (!isNaN(d.getTime())) return d.getTime();
                    const n = Number(val);
                    if (!isNaN(n)) return n;
                    return 0;
                };
                return parseDate(b.startdate || b.date) - parseDate(a.startdate || a.date);
            });
            setRounds(sorted);
        } catch (err) {
            console.error("ViewRounds: Error fetching rounds", err);
        }
    };
    const fetchDrives = async () => {
        try {
            const url = `${apiConfig.getResourceUrl("drive")}?queryId=GET_ALL`;
            const response = await apiFetch(url);
            if (response.ok) {
                const data = await response.json();
                let rawDrives = [];
                if (Array.isArray(data)) rawDrives = data;
                else if (data && Array.isArray(data.resource)) rawDrives = data.resource;
                else if (data && Array.isArray(data.records)) rawDrives = data.records;
                setDrives(rawDrives);
            }
        } catch (err) {
            console.error("ViewRounds: Error fetching drives", err);
        }
    };
    useEffect(() => {
        fetchRounds();
    }, [id]);

    useEffect(() => {
        fetchDrives();
    }, []);

    const { data: fetchedDataById, isLoading: loadingEditComp, refetch } = useQuery({
        queryKey: ["getById", "Application", id],
        queryFn: async () => {
            const params = new URLSearchParams({
                args: `id:${id}`,
                queryId: "GET_BY_ID",
            });

            const res = await apiFetch(`${apiConfig.getResourceUrl("applications")}?${params.toString()}`);
            if (!res.ok) throw new Error("Fetch failed");
            return res.json();
        },
        enabled: !!id,
    });

    useEffect(() => {
        const fetchedApp = fetchedDataById?.resource?.[0];
        const driveId = fetchedApp?.drive_id;
        if (!driveId || rounds.length === 0 || drives.length === 0) return;

        const drive = drives.find(d => d.id === driveId);
        const isMtech = drive?.drivetype === "Mtech";

        let targetRoundId = fetchedApp?.online_round5_offered_round_id || fetchedApp?.online_round5_id || fetchedApp?.online_round4_offered_round_id || fetchedApp?.online_round4_id || fetchedApp?.online_round3_offered_round_id || fetchedApp?.online_round3_id || fetchedApp?.online_round2_offered_round_id || fetchedApp?.online_round2_id || fetchedApp?.onlineRound;
        let round = rounds.find((r) => r.id === targetRoundId);
        
        if (!round) {
             round = rounds.find((r) => r.round_type === "Online" && r.drive_id === driveId && r.round_number === 4) 
                  || rounds.find((r) => r.round_type === "Online" && r.drive_id === driveId && r.round_number === 3) 
                  || rounds.find((r) => r.round_type === "Online" && r.drive_id === driveId && r.round_number === 2)
                  || rounds.find((r) => r.round_type === "Online" && r.drive_id === driveId);
        }
        if (round) {
            setSelectedRound(round);
            const btcseExhausted = round?.btcse_exhausted === true;
            const bteceExhausted = round?.btece_exhausted === true;
            const btaidsExhausted = round?.btaids_exhausted === true;
            const imtcseExhausted = round?.imtcse_exhausted === true;
            const imteceExhausted = round?.imtece_exhausted === true;
            const mtcseExhausted = round?.mtcse_exhausted === true;
            const mteceExhausted = round?.mtece_exhausted === true;
            const mtaidsExhausted = round?.mtaids_exhausted === true;

            if (isMtech) {
                setAnalytics({
                    programme1: "MTech_CSE",
                    programme2: "MTech_ECE",
                    programme3: "MTech_AI_DS",
                    programme4: "",
                    programme5: "",
                    seatsavailable1: mtcseExhausted ? 0 : (round?.mtech_online_cse_remaining ?? round?.mtech_online_cse_seats ?? 0),
                    seatsavailable2: mteceExhausted ? 0 : (round?.mtech_online_ece_remaining ?? round?.mtech_online_ece_seats ?? 0),
                    seatsavailable3: mtaidsExhausted ? 0 : (round?.mtech_online_aids_remaining ?? round?.mtech_online_aids_seats ?? 0),
                    seatsavailable4: 0,
                    seatsavailable5: 0,
                    lastUpdated1: round?.mtech_online_cse_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated2: round?.mtech_online_ece_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated3: round?.mtech_online_aids_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated4: "",
                    lastUpdated5: "",
                });
            } else {
                setAnalytics({
                    programme1: "BTech_CSE",
                    programme2: "BTech_ECE",
                    programme3: "BTech_AI_DS",
                    programme4: "I_MTech_CSE",
                    programme5: "I_MTech_ECE",
                    seatsavailable1: btcseExhausted ? 0 : (round?.btech_online_cse_remaining ?? round?.btech_online_cse_seats ?? 0),
                    seatsavailable2: bteceExhausted ? 0 : (round?.btech_online_ece_remaining ?? round?.btech_online_ece_seats ?? 0),
                    seatsavailable3: btaidsExhausted ? 0 : (round?.btech_online_aids_remaining ?? round?.btech_online_aids_seats ?? 0),
                    seatsavailable4: imtcseExhausted ? 0 : (round?.imtech_online_cse_remaining ?? round?.imtech_online_cse_seats ?? 0),
                    seatsavailable5: imteceExhausted ? 0 : (round?.imtech_online_ece_remaining ?? round?.imtech_online_ece_seats ?? 0),
                    lastUpdated1: round?.btech_online_cse_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated2: round?.btech_online_ece_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated3: round?.btech_online_aids_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated4: round?.imtech_online_cse_last_updated ?? round?.last_updated_at ?? "",
                    lastUpdated5: round?.imtech_online_ece_last_updated ?? round?.last_updated_at ?? "",
                });
            }
        }
    }, [rounds, fetchedDataById, drives]);

    console.log("analytics", analytics)
    const baseUrl = apiConfig.getResourceUrl("Drive");

    const isMtech = drives.find((d: any) => d.id === fetchedDataById?.resource?.[0]?.drive_id)?.drivetype === "Mtech";
    const isBtechOnlineRound2 = !isMtech && selectedRound?.round_type === "Online" && selectedRound?.round_number === 2;
    const isBtechOnlineRound3 = !isMtech && selectedRound?.round_type === "Online" && selectedRound?.round_number === 3;
    const isBtechOnlineRound5 = !isMtech && selectedRound?.round_type === "Online" && selectedRound?.round_number === 5;
    const isBtechOnlineRound4 = !isMtech && selectedRound?.round_type === "Online" && selectedRound?.round_number === 4;
    const tokenField = isBtechOnlineRound5 ? fetchedDataById?.resource?.[0]?.online_round5_token : (isBtechOnlineRound4 ? fetchedDataById?.resource?.[0]?.online_round4_token : (isBtechOnlineRound3 ? fetchedDataById?.resource?.[0]?.online_round3_token : (isBtechOnlineRound2 ? fetchedDataById?.resource?.[0]?.online_round2_token : fetchedDataById?.resource?.[0]?.online_round_token)));
    const iir = tokenField || fetchedDataById?.resource?.[0]?.iir;

    useEffect(() => {
        setToken(parseInt(iir))
    }, [iir])

    const fetchApplicationByIIR = async (iir: number): Promise<number | null> => {
        setLoading(true);

        try {
            const driveId = fetchedDataById?.resource?.[0]?.drive_id;
            let args = `iir:${iir}`;
            if (driveId) {
                args += `,drive_id:${driveId}`;
            }
            if (selectedRound?.id) {
                args += `,round_id:${selectedRound.id}`;
            }
            const url = `${apiConfig.getResourceUrl(
                "applications"
            )}?queryId=GET_APPLICATION_BY_IIR&args=${encodeURIComponent(args)}`;

            const response = await apiFetch(url);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            const apps = Array.isArray(data)
                ? data
                : Array.isArray(data?.resource)
                    ? data.resource
                    : [];

            const appId = apps?.[0]?.id;

            if (appId) {
                return appId;
            }

            toast.info(`Application not found for token number ${iir}`);
            return null;
        } catch (err) {
            console.error("Unable to load application", err);
            toast.error("Unable to load application");
            return null;
        } finally {
            setLoading(false);
        }
    };

    const handleViewOnlineRound = async (prev: boolean, next: boolean) => {
        let appId
        if(prev && token){
            appId = await fetchApplicationByIIR(token-1);
        } if(next && token) {
            appId = await fetchApplicationByIIR(token+1);
        }

        if (appId) {
            navigate(`/btech-online-display/${appId}`);
            console.log("Application ID:", appId);
        }
    }



    function formatDate(dateString: string): string {
        if (!dateString) return "NA";
        const cleaned = dateString
            // Remove [Asia/Kolkata]
            .replace(/\[.*\]$/, "")
            // Keep only milliseconds (3 digits)
            .replace(/\.(\d{3})\d+/, ".$1");

        return moment.parseZone(cleaned).format("DD-MM-YYYY hh:mm A");
    }

    const handleSearch = async () => {
        const appId = await fetchApplicationByIIR(parseInt(searchText));

        if (appId) {
            navigate(`/btech-online-display/${appId}`);
            console.log("Application ID:", appId);
        }
    }
    return (
        <div className="student-home-container">
            {/* Header */}
            <header className="student-header">
                <div className="header-left">
                    <img src={iiitblogo} alt="IIITB" className="header-logo" />
                    <div className="header-title-group">
                        <h1 className="header-inst-name">
                            International Institute of Information Technology Bangalore
                        </h1>
                        <span className="header-portal-name">Admissions Portal</span>
                    </div>
                </div>
                <div className="header-right">
                    <div className="user-profile">
                        <div className="user-avatar" title={userEmail}>
                            <UserIcon size={20} />
                        </div>
                        <span className="user-email-text">{userEmail.split("@")[0]}</span>
                    </div>
                    {isAdmin ?
                        <button className="logout-btn" onClick={() => { navigate("/viewrounds/online") }}>
                            <LogOut size={16} />
                            <span>Go To Rounds</span>
                        </button>
                        :
                        <LogoutButton className="logout-btn" />
                    }
                </div>
            </header>

            <div style={{ padding: 24 }}>
                <h3 style={{ marginBottom: "15px", textAlign: "center", fontWeight: 600 }}>{selectedRound?.name} - Seat Allocation Status</h3>
                <h4 style={{ marginBottom: "15px", textAlign: "center", fontWeight: 600 }}>Drive: {drives.find(d => d.id === fetchedDataById?.resource?.[0]?.drive_id)?.drivetype === "Mtech" ? "M.Tech" : "B.Tech & Integrated M.Tech"}</h4>
                {isAdmin &&
                    <div style={{ marginLeft: "40px", marginRight: "40px" }}>
                        <div style={{ display: "flex", gap: 20, marginBottom: 20, justifyContent: "end", marginRight: 20 }}>
                            <input
                                type="text"
                                className="form-control bg-white shadow-sm"
                                placeholder="Enter Token Number"
                                value={searchText}
                                onChange={(e) => { setSearchText(e.target.value) }}
                                style={{
                                    padding: "6px 10px", borderRadius: "6px",
                                    border: "1px solid #d1d5db", fontSize: "13px",
                                    color: "#374151", backgroundColor: "#fff", flex: '0 1 250px'
                                }}
                            />
                            <button
                                className="btn btn-primary btn-sm fw-medium px-4 text-white border-0 shadow-sm me-2"
                                onClick={handleSearch}
                                style={{ borderRadius: "6px", height: "36px", backgroundColor: "#3b82f6" }}
                            >
                                Search
                            </button>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                className="apply-btn"
                                onClick={() => handleViewOnlineRound(true, false)}
                                style={{ width: "auto", backgroundColor: '#15c63ece', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
                            >
                                Previous Token
                            </button>
                            <button
                                className="apply-btn"
                                onClick={() => handleViewOnlineRound(false, true)}
                                style={{ width: "auto", backgroundColor: '#15c63ece', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
                            >
                                Next Token
                            </button>
                        </div>
                    </div>
                }
                <div style={{ marginLeft: 44, marginRight: 44, marginTop: 20, marginBottom: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h5 style={{ fontWeight: 600, margin: 0 }}>Token Number - {""}
                        <span style={{ fontWeight: 600 }}>
                            {iir ?? "NA"}
                        </span>
                    </h5>
                    <h5 style={{ fontWeight: 600, margin: 0 }}>
                        Best JEE Rank (BJR): {""}
                        <span style={{ fontWeight: 600 }}>
                            {fetchedDataById?.resource?.[0]?.bjr ?? "NA"}
                        </span>
                    </h5>
                </div>

                {iir && <div style={{ padding: 24 }}>
                    {analyticsLoading ? (
                        <div className="analytics-loading">Loading analytics...</div>
                    ) : analytics ? (
                        <div className="analytics-table-wrapper" style={{ marginBottom: "40px", overflow: "scroll" }}>
                            <table className="analytics-table">
                                <thead>
                                    <tr>
                                        <th>Programme</th>
                                        <th>Seats Available</th>
                                        <th>Last Updated</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="analytics-row-total">
                                        <td><strong>{programmeFullNames[analytics.programme1] || analytics.programme1}</strong></td>
                                        <td><strong>{n(analytics.seatsavailable1)}</strong></td>
                                        <td><strong>{formatDate(analytics.lastUpdated1)}</strong></td>
                                    </tr>
                                    <tr className="analytics-row-total">
                                        <td><strong>{programmeFullNames[analytics.programme2] || analytics.programme2}</strong></td>
                                        <td><strong>{n(analytics.seatsavailable2)}</strong></td>
                                        <td><strong>{formatDate(analytics.lastUpdated2)}</strong></td>
                                    </tr>
                                    <tr className="analytics-row-total">
                                        <td><strong>{programmeFullNames[analytics.programme3] || analytics.programme3}</strong></td>
                                        <td><strong>{n(analytics.seatsavailable3)}</strong></td>
                                        <td><strong>{formatDate(analytics.lastUpdated3)}</strong></td>
                                    </tr>
                                    {analytics.programme4 && (
                                        <tr className="analytics-row-total">
                                            <td><strong>{programmeFullNames[analytics.programme4] || analytics.programme4}</strong></td>
                                            <td><strong>{n(analytics.seatsavailable4)}</strong></td>
                                            <td><strong>{formatDate(analytics.lastUpdated4)}</strong></td>
                                        </tr>
                                    )}
                                    {analytics.programme5 && (
                                        <tr className="analytics-row-total">
                                            <td><strong>{programmeFullNames[analytics.programme5] || analytics.programme5}</strong></td>
                                            <td><strong>{n(analytics.seatsavailable5)}</strong></td>
                                            <td><strong>{formatDate(analytics.lastUpdated5)}</strong></td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="analytics-loading">No data available.</div>
                    )}
                </div>}
            </div>

        </div>
    )
}

export default BtechOnlineRoundDisplay